import React, { useState, useEffect } from 'react';
import { Col, Row, Form, FormGroup, Input, Button, Spinner, CardBody, CardHeader, Label, Card } from 'reactstrap';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import ReadMoreContent from '../Utilities/Ui/ReadMore';
import './CatchmentContext.css';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const BiodiversityInfo = ({ setSignificantBiodiversityChanged, biodiversityDesc, setBiodiversityDesc }) => {
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [saving, setSaving] = useState('');
    
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));

    useEffect(() => {
        getOtherInfo();

    }, [])

    const getOtherInfo = async () => {
        try {
            const response = await apiGet('/api/catchmentContext/getBiodiversityInfo/', {
                params: {
                    farmId: farmId
                }
            });

            setBiodiversityDesc(response?.data?.description);

        } catch (error) {
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    

    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Col>
                <Card>
                    <CardHeader className="card-header-dark">
                        <h5>Significant Biodiversity</h5>
                    </CardHeader>
                    <CardBody>
                        <Form>
                            <Row>
                                <Col>
                                    {/*<ReadMoreContent longText="Areas identified as having significant biodiversity in regional plan or catchment context document. Significant biodiversity refers to diversity of species, particularly native plants, insects, birds, bats, and/or aquatic species." />*/}
                                    <p>Areas identified as having significant biodiversity in regional plan or catchment context document. Significant biodiversity refers to diversity of species, particularly native plants, insects, birds, bats, and/or aquatic species.</p>
                                    <Row>
                                        <FormGroup>
                                            <Col>
                                                <Input
                                                    id="description"
                                                    name="description"
                                                    type="textarea"
                                                    value={biodiversityDesc}
                                                    onChange={(e) => { setBiodiversityDesc(e.target.value); setSignificantBiodiversityChanged(true) } }
                                                    
                                                />
                                            </Col>
                                        </FormGroup>
                                    </Row>
                                    <br />
                                </Col>
                            </Row>
                            {/*{(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&*/}
                            {/*    <>*/}
                            {/*        {saving ?*/}
                            {/*            <Button style={{ float: "right" }}*/}
                            {/*                color="success"*/}
                            {/*                disabled*/}
                            {/*            >*/}
                            {/*                <Row>*/}
                            {/*                    <Col sm="8">*/}
                            {/*                        <span>*/}
                            {/*                            {' '}Saving*/}
                            {/*                        </span>*/}
                            {/*                    </Col>*/}
                            {/*                    <Col sm="4">*/}
                            {/*                        <Spinner size="sm">*/}
                            {/*                            Saving...*/}
                            {/*                        </Spinner>*/}
                            {/*                    </Col>*/}
                            {/*                </Row>*/}
                            {/*            </Button>*/}
                            {/*            :*/}
                            {/*            <Button style={{ float: "right" }} color="success" size="sm">*/}
                            {/*                Save*/}
                            {/*            </Button>*/}
                            {/*        }*/}
                            {/*    </>*/}
                            {/*}*/}
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default BiodiversityInfo